export default __webpack_public_path__ + "static/media/Commissioner-Regular.d3087ff2.ttf";